import React from "react"
import PropTypes from "prop-types"

import "./layout.css"
import Header from "./header"
import Footer from "./footer"

const Layout = ({ hero: Hero, isFullWidth=false, headerId, children }) => (
  <>
    {
      Hero && <Hero />
    }
    <Header id={headerId} isFixed={!Hero} />
    <div
      style={{
        margin: `0 auto`,
        maxWidth: isFullWidth ? 'unset' : 960,
      }}
    >
      <main>{children}</main>
    </div>
    <Footer />
  </>
)

Layout.propTypes = {
  hero: PropTypes.any,
  children: PropTypes.node.isRequired,
}

export default Layout
